import { c as _c } from "react/compiler-runtime";
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
type ClickType = 'cta' | 'product_image' | 'title';
export const useAlternatePickClickAnalytics = (clickType, parentActivityId) => {
  const $ = _c(5);
  let t0;
  if ($[0] !== clickType || $[1] !== parentActivityId) {
    t0 = {
      actionName: "alt_pick",
      actionSection: clickType,
      actionType: "press",
      actionInput: undefined,
      parentActivityId
    };
    $[0] = clickType;
    $[1] = parentActivityId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const fireClickPageAction = usePageAction(t0);
  let t1;
  if ($[3] !== fireClickPageAction) {
    t1 = {
      fireClickPageAction
    };
    $[3] = fireClickPageAction;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};